import { render, staticRenderFns } from "./CheeseTreatmentsBase.vue?vue&type=template&id=db88327e&scoped=true"
import script from "./CheeseTreatmentsBase.vue?vue&type=script&lang=ts"
export * from "./CheeseTreatmentsBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db88327e",
  null
  
)

export default component.exports